import {
    IServiceResult,
    ITerritoryType,
    ITerritoryTypePermission,
} from "../Models/Models";

export interface ITerritoryManagementAxios {
  GetTerritoryTypePermissions(
    territoryTypeID: number
  ): Promise<IServiceResult<Array<ITerritoryTypePermission>>>;
  UpdateTerritoryTypeAdminOnlyProperty(
    territoryType: ITerritoryType
  ): Promise<IServiceResult<number>>;
  UpdateTerritoryTypeUserPermissions(
    userID: number,
    territoryTypeID: number,
    canView: boolean,
    canEdit: boolean
  );
  UpdateTerritoryTypeUserPermissionsForAll(
    territoryPermissions: Array<ITerritoryTypePermission>
  );
}
